<template>
  <div class="stock">
    <van-notice-bar wrapable :scrollable="false" text="请核对信息，若有误请点击进行修改" />
    <van-field v-model="assetObj.asset_num" required label="资产编码" label-width="110" right-icon="scan"
      placeholder="扫码获取资产编码" @click-right-icon="onScan" @blur="inputFinish" />
      <van-field v-model="assetObj.sn" label="序列号"  label-width="110" right-icon="scan"
      placeholder="扫码获取序列号" @click-right-icon="onScansn" @blur="inputFinishsn" />
    <van-field v-model="assetObj.asset_describe" required label="资产描述" disabled />
    <van-field v-model="assetObj.cost_center" required label="成本中心" disabled />
    <van-field v-model="assetObj.stock_p" label="盘点计划" disabled />
    <van-field v-model="assetObj.stock_name" label="盘点名称" disabled />

    <van-field label="存货号" v-model="assetObj.stock_number" placeholder="" disabled />
    <van-field label="正确存货号" v-model="assetObj.true_number" placeholder="请输入正确存货号" error-message="默认存货号有误时填写" />
    <van-field v-model="assetObj.device_number" label="数量" required type="number" placeholder="请输入数量" />
    <van-field v-model="assetObj.management" label="盘点负责部门" placeholder="" disabled />
    <van-field readonly clickable name="picker" :value="assetObj.Status" label="资产状态" placeholder="点击选择资产状态"
      @click="showAssetState = true" required/>
    <van-field readonly clickable name="picker" :value="assetObj.label" label="标签状况" placeholder="点击选择标签状况"
      @click="showLabelStatus = true" required/>
    <!-- <van-field
      readonly
      clickable
      name="picker"
      :value="assetObj.supervisor_status"
      label="监盘状态"
      placeholder="点击选择监盘状态"
      @click="showSupervisorStatus = true"
    /> -->

    <van-divider content-position="left">{{
        $t("message.photoTip1")
    }}</van-divider>

    <ChooseImgs class="stock-img" @finish="photo1" ref="chooseImg1" :stockType="photoRequired ? 'list' : ''"/>

    <template v-if="showPicUrls.length">
      <van-divider content-position="left">历史照片</van-divider>
      <div class="stock-history">
        <van-image
          v-for="(item, index) in showPicUrls"
          :key="index"
          class="stock-img"
          width="80"
          height="80"
          fit="cover"
          :src="item" />
      </div>
    </template>

    <van-field v-model="assetObj.comments" clearable :placeholder="$t('message.remarksTip')"
      :label="$t('message.remarks')" type="textarea" maxlength="200" autosize show-word-limit />

    <div class="stock-submit">
      <van-button round type="primary" :loading="submitting" :loading-text="$t('message.submitTip')" @click="onSubmit">
        {{ $t("message.submit") }}
      </van-button>
    </div>
    <!-- 资产状态弹窗 -->
    <van-popup v-model="showAssetState" position="bottom">
      <van-picker show-toolbar :columns="assetStateOpt" @confirm="onStateConfirm" @cancel="showAssetState = false" />
    </van-popup>
    <!-- 标签状况弹窗 -->
    <van-popup v-model="showLabelStatus" position="bottom">
      <van-picker show-toolbar :columns="labelStatusOpt" @confirm="onStatusConfirm" @cancel="showLabelStatus = false" />
    </van-popup>
    <!-- 监盘状态 -->
    <van-popup v-model="showSupervisorStatus" position="bottom">
      <van-picker show-toolbar :columns="supervisorStatusOpt" @confirm="onSupervisorConfirm"
        @cancel="showSupervisorStatus = false" />
    </van-popup>
  </div>
</template>

<script>
import {
  Button,
  Image,
  Field,
  Icon,
  Cell,
  CellGroup,
  Divider,
  SwitchCell,
  Toast,
  Dialog,
  NoticeBar,
  Popup,
  Picker,
} from "vant";
import { jsConfig } from "@/api/wx";
import ChooseImgs from "@/components/chooseImgs";
import { runInNewContext } from "vm";
export default {
  components: {
    ChooseImgs,
    [Popup.name]: Popup,
    [Button.name]: Button,
    [Image.name]: Image,
    [Field.name]: Field,
    [Icon.name]: Icon,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Divider.name]: Divider,
    [SwitchCell.name]: SwitchCell,
    [Picker.name]: Picker,
    Toast,
    Dialog,
    [NoticeBar.name]: NoticeBar,
  },

  computed: {
    // showPics无历史照片时，标签照片必填
    photoRequired() {
      return !this.showPicUrls.length;
    },
  },

  data() {
    return {
      assetOld: {},
      assetObj: {
        picture: []
      },
      loading: false,
      stockType: "",
      submitting: false,
      showAssetState: false,
      showLabelStatus: false,
      showSupervisorStatus: false,
      assetStateOpt: [
        "在用",
        "闲置",
        "部分闲置",
        "待处置",
        "处置",
        "部分处置",
        "盘盈",
        "盘亏",
      ],
      labelStatusOpt: ["良好", "已损坏"],
      supervisorStatusOpt: ["待监盘", "已监盘"],
      showPicUrls: [],
      action: ''
    };
  },
  mounted() {
    let { id } = this.$route.query;
    this.action = this.$route.query.action;
    if (id) {
      this.$nextTick(() => {
        this.stockType = "list";
        this.getAsset("id", id, 'route');
      });
    }
    this.$wx.ready(() => {
      this.$wx.getLocation({
        type: "wgs84", // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入"gcj02"
        success: (res) => {
          this.$axios
            .get("wx/location?lat=" + res.latitude + "&lng=" + res.longitude)
            .then((addr) => {
              Toast(addr ? "定位：" + addr : "定位异常");
              this.address = addr;
            });
        },
        fail() {
          Toast("定位失败");
        },
      });
    });
    jsConfig();
  },
  methods: {
    // 解析showPics历史照片
    setShowPics(showPics) {
      this.showPicUrls = showPics
        ? showPics
            .split(",")
            .filter((item) => item)
            .map((item) => "https://dan.cp.asset.mspcloud.top/dan/" + item + ".jpg")
        : [];
    },
    // 二维码扫码
    onScan() {
      let that = this
      console.log('我来调用扫码')
      this.$wx.scanQRCode({
        desc: "资产二维码",
        needResult: 1, // 默认为0，扫描结果由企业微信处理，1则直接返回扫描结果，
        scanType: ["qrCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: (res) => {
          console.log('res', res)
          let value = res.resultStr
          that.assetObj.asset_num = res.resultStr.split("/n")[0];
          // that.assetObj.sn = res.resultStr.split(" ")[1];
          that.stockType = "qrcode";
          console.log('asset_num', that.assetObj.asset_num)
          that.getAsset("qrcode", value, 'scan');
        },
        error: (res) => {
          if (res.errMsg.indexOf("function_not_exist") > 0) {
            Toast("版本过低请升级");
          } else {
            Toast("调用扫码失败");
          }
        },
      });

    },
    onScansn() {
      let that = this
      console.log('我来调用扫码')
      this.$wx.scanQRCode({
        desc: "序列号二维码",
        needResult: 1, // 默认为0，扫描结果由企业微信处理，1则直接返回扫描结果，
        scanType: ["qrCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: (res) => {
          console.log('res', res)
          let value = res.resultStr
          that.assetObj.sn = res.resultStr.split("/n")[0];
          // that.assetObj.sn = res.resultStr.split(" ")[1];
          that.stockType = "qrcode";
          console.log('sn', that.assetObj.sn)
          that.getAssetsn("qrcode", value, 'scan');
        },
        error: (res) => {
          if (res.errMsg.indexOf("function_not_exist") > 0) {
            Toast("版本过低请升级");
          } else {
            Toast("调用扫码失败");
          }
        },
      });

    },
    // 资产状态确认
    onStateConfirm(value) {
      this.assetObj.Status = value;
      this.showAssetState = false;
    },
    // 标签状况确认
    onStatusConfirm(value) {
      this.assetObj.label = value;
      this.showLabelStatus = false;
    },
    // 监盘状态确认
    onSupervisorConfirm(value) {
      this.assetObj.supervisor_status = value;
      this.showSupervisorStatus = false;
    },
    // 扫码失焦
    inputFinish() {
      this.stockType = "input";
      this.getAsset("asset_num", this.assetObj.asset_num, 'input');
    },
    inputFinishsn() {
      this.stockType = "input";
      this.getAssetsn("sn", this.assetObj.sn, 'input');
    },
    getAsset(type, value, readType) {
      this.$refs.chooseImg1.refresh();
      this.showPicUrls = [];
      console.log('---readType---', readType)
      console.log('----this.$refs----', this.$refs)
      this.$axios
        .get(
          "device/query?type=" + type + "&value=" + encodeURIComponent(value)
        )
        .then((res) => {
          this.setShowPics(res.showPics);
          if (res.stock_status == "已盘点") {
            Toast("该资产已盘点完成");
          }
          if (readType == 'input') {
            let assetNumFalg = this.assetObj.asset_num
            this.assetObj = res;
            this.assetObj.asset_num = assetNumFalg
            if (!this.assetObj.label) {
              this.assetObj.label = "良好"
            }
            if (!this.assetObj.Status) {
              this.assetObj.Status = "在用"
            }
            // if(!this.assetObj.picture) {
              this.assetObj.picture = []
              this.assetOld.picture = []
            // }
            this.assetOld = JSON.parse(JSON.stringify(res));
            this.assetObj.asset_num = assetNumFalg
          } else if (readType == 'scan' || readType == 'route') {
            console.log('-----获取到的值', res)
            
            this.assetObj.picture = []
            this.assetObj = JSON.parse(JSON.stringify(res))
            this.assetOld = {
              asset_num: res.asset_num,
              asset_describe: res.asset_describe,
              category_name: res.category_name,
              sn: res.sn,
              stock_p: res.stock_p,
              stock_name: res.stock_name,
              stock_number: res.stock_number,
              true_number: res.true_number,
              management: res.management,
              true_management: res.true_management,
              Status: res.Status,
              label: res.label,
              comments: res.comments,
              picture: res.picture,
              id: res.id
            };
            if (!this.assetObj.label) {
              this.assetObj.label = "良好"
              this.assetOld.label="良好"
            }
            if (!this.assetObj.Status) {
              this.assetObj.Status = "在用"
              this.assetOld.Status = "在用"
            }
              this.assetObj.picture = []
              this.assetOld.picture = []
            console.log('-----assetOld的值', this.assetOld)
          }

        });
    },
    getAssetsn(type, value, readType) {
      this.$refs.chooseImg1.refresh();
      this.showPicUrls = [];
      console.log('---readType---', readType)
      console.log('----this.$refs----', this.$refs)
      this.$axios
        .get(
          "device/queryBySN?type=" + type + "&value=" + encodeURIComponent(value)
        )
        .then((res) => {
          this.setShowPics(res.showPics);
          if (res.stock_status == "已盘点") {
            Toast("该资产已盘点完成");
          }
          if (readType == 'input') {
            let snFalg = this.assetObj.sn
            this.assetObj = res;
            this.assetObj.sn = snFalg
            if (!this.assetObj.label) {
              this.assetObj.label = "良好"
            }
            if (!this.assetObj.Status) {
              this.assetObj.Status = "在用"
            }
            // if(!this.assetObj.picture) {
              this.assetObj.picture = []
              this.assetOld.picture = []
            // }
            this.assetOld = JSON.parse(JSON.stringify(res));
            this.assetObj.sn = snFalg
          } else if (readType == 'scan' || readType == 'route') {
            console.log('-----获取到的值', res)
            
            this.assetObj.picture = []
            this.assetObj = JSON.parse(JSON.stringify(res))
            this.assetOld = {
              asset_num: res.asset_num,
              asset_describe: res.asset_describe,
              category_name: res.category_name,
              sn: res.sn,
              stock_p: res.stock_p,
              stock_name: res.stock_name,
              stock_number: res.stock_number,
              true_number: res.true_number,
              management: res.management,
              true_management: res.true_management,
              Status: res.Status,
              label: res.label,
              comments: res.comments,
              picture: res.picture,
              id: res.id
            };
            if (!this.assetObj.label) {
              this.assetObj.label = "良好"
              this.assetOld.label="良好"
            }
            if (!this.assetObj.Status) {
              this.assetObj.Status = "在用"
              this.assetOld.Status = "在用"
            }
              this.assetObj.picture = []
              this.assetOld.picture = []
            console.log('-----assetOld的值', this.assetOld)
          }

        });
    },
    photo1(id) {
      console.log('照片', id)
      this.assetObj.picture.push(id);
      console.log('上传的图片路径', this.assetObj.picture)
    },
    onSubmit() {
      if (!this.assetObj.id) {
        Toast("请输入需要盘点的资产编码");
        return;
      }
      if(!this.assetObj.Status) {
        Toast("请选择资产状态");
        return;
      }
      if(!this.assetObj.label) {
        Toast("请选择资产标签状况");
        return;
      }
      if(!this.assetObj.device_number && this.assetObj.device_number !== 0) {
        Toast("请填写数量");
        return;
      }
      if(this.photoRequired && this.assetObj.picture.length==0) {
        Toast("请上传资产照片");
        return;
      }
      console.log("")
      // if (this.action && this.action.indexOf('盘点') > -1 && this.assetObj.picture.length == 0) {
      //   Toast("请上传资产照片");
      //   return;
      // }
      //   if (!this.remark) {
      //     Toast("请输入备注");
      //     return;
      //   }
      // let changeFields = Object.keys(this.assetOld).filter((item) => {
      //   return this.assetOld[item] != this.assetObj[item];
      // });
      // const stock_question = changeFields.length > 0 || this.assetObj.comments ? "1" : "0";

      this.submitting = true;
      if (this.action) {
        this.assetObj.action = this.action.slice(1)
      } else {
        this.assetObj.action = ""
      }
      this.assetObj.stockType = this.stockType
      console.log('assetObj', this.assetObj)
      this.assetObj.picture = JSON.stringify(this.assetObj.picture);
      this.$axios
        .post("device/stock",
          this.assetObj)
        .then((number) => {
          const message =
            '当前资产已完成盘点，盘点信息可以在"盘点记录"查看；\n' +
            (number > 0 ? `您当前还有${number}个资产未盘点，请继续` : "");
          Dialog({
            title: "提交成功",
            message,
          });
          this.submitting = false;
          (this.assetObj = {}),
            (this.stockType = "");
          this.$refs.chooseImg1.refresh();
          if (this.action) {
            this.$router.push({
              name: 'myStock',
              query: { type: this.action }
            })
          } else {
            this.$router.push({
              name: '/',
            })
          }
        })
        .catch((res) => {
          Dialog({ message: "盘点失败\n" + res });
          this.submitting = false;
        });
    },
  },
};
</script>

<style lang="less">
.stock {
  padding: 20px 0 50px 0;

  &-assetDetail {
    padding: 10px 20px;
  }

  &-img {
    margin-left: 20px;
  }

  &-history {
    display: flex;
    flex-wrap: wrap;
  }

  &-submit {
    text-align: center;

    button {
      padding: 0 50px;
      margin: 20px auto;
    }
  }
}
</style>
